// eslint-disable-next-line no-unused-vars
import { Response, Server } from 'miragejs';
import environment from '@/environment';

/**
 *
 * @param {Server} server
 */
export default (server) => {

  // Delete user endpoint.
  server.delete(`${environment.getApiGatewayUrl()}/v1/users/:id`, () => {});

  // Create user endpoint.
  server.post(`${environment.getApiGatewayUrl()}/v1/users`, (schema, request) => {
    const attrs = JSON.parse(request.requestBody);
    server.create('user', attrs);
  });

  // Update user endpoint.
  server.patch(`${environment.getApiGatewayUrl()}/v1/users/:id`, (schema, request) => {
    const attrs = JSON.parse(request.requestBody);
    const user = schema.users.find(request.params.id);
    user.update(attrs);
  });

  // eslint-disable-next-line func-names
  server.get(`${environment.getApiGatewayUrl()}/v1/users`, function (schema, request) {
    /*
     * Perform manual pagination for demonstration purposes.
     */
    const users = this.serialize(schema.users.all());

    const page = parseInt(request.queryParams.page, 10);
    const maxPerPage = parseInt(request.queryParams.maxPerPage, 10);

    const startIndex = page * maxPerPage;
    const endIndex = Math.min(startIndex + maxPerPage - 1, users.users.length - 1);

    const displayUsers = users.users.slice(startIndex, endIndex + 1);

    return new Response(
      200,
      {
        'X-Total-Count': users.users.length,
      },
      displayUsers
    );
  });
};
